import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuBlueComponent } from './icons/menu-blue/menu-blue.component';
import { AddButtonComponent } from './icons/add-button/add-button.component';
import { ArrowBackComponent } from './icons/arrow-back/arrow-back.component';

const icons = [AddButtonComponent, MenuBlueComponent, ArrowBackComponent];

@NgModule({
  declarations: [...icons],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [...icons],
})
export class IconsModule {}
